'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of checklist
 */ const Checklist = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "29.7969",
                y: "24.1719",
                width: "44.6919",
                height: "58.0433",
                rx: "2.91389",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.1292 43.2598C34.7694 42.9 34.7694 42.3169 35.1292 41.9566C35.4889 41.5969 36.0726 41.5969 36.4323 41.9566L38.0894 43.6131L42.0748 39.0049C42.3966 38.6131 42.9755 38.557 43.3667 38.8788C43.7585 39.2006 43.8147 39.7795 43.4929 40.1707L38.9131 45.5021C38.8815 45.5475 38.8457 45.5913 38.8051 45.632C38.4454 45.9917 37.8617 45.9917 37.5019 45.632L35.1292 43.2598Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.7664 20.1054H63.5559C64.3988 20.1054 65.0822 20.7888 65.0822 21.6318V26.1683C65.0822 27.0113 64.3988 27.6946 63.5559 27.6946H40.8896C40.0466 27.6946 39.3633 27.0113 39.3633 26.1683V21.6318C39.3633 20.7888 40.0466 20.1054 40.8896 20.1054H46.6645C46.7004 17.0704 49.1719 14.6211 52.2154 14.6211C55.259 14.6211 57.7305 17.0704 57.7664 20.1054Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "34.8594",
                y: "65.7578",
                width: "6.88649",
                height: "6.88649",
                rx: "1.38757",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "47.4922",
                y: "39.6699",
                width: "22",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "47.4922",
                y: "43.6699",
                width: "22",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.1292 57.2598C34.7694 56.9 34.7694 56.3169 35.1292 55.9566C35.4889 55.5969 36.0726 55.5969 36.4323 55.9566L38.0894 57.6131L42.0748 53.0049C42.3966 52.6131 42.9755 52.557 43.3667 52.8788C43.7585 53.2006 43.8147 53.7795 43.4929 54.1707L38.9131 59.5021C38.8815 59.5475 38.8457 59.5913 38.8051 59.632C38.4454 59.9917 37.8617 59.9917 37.5019 59.632L35.1292 57.2592V57.2598Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "47.4922",
                y: "53.502",
                width: "22",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "47.4922",
                y: "57.6699",
                width: "22",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "47.4922",
                y: "66.6699",
                width: "22",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "47.4922",
                y: "70.8379",
                width: "22",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.Checklist = Checklist;
//# sourceMappingURL=Checklist.cjs.map
